import React from "react";
import { Link } from "react-router-dom";

export default function Bottom() {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-4 fixed-bottom">
      © 2025 www.asianclimatecontrols.com | All Rights Reserved
    </footer>
  );
}
